

exports.__esModule = true;
exports.$SelectFiRoute = undefined;

var _squid = require('squid');

var _directive = require('./directive');

var $SelectFiRoute = exports.$SelectFiRoute = _squid.$ComponentRoute.extend('$SelectFiRoute', {

    path: 'selectFi',
    directive: _directive.$xoSelectFiComponent,
    titleContent: 'memberReview.selectFi',
    trackingData: {
        fptiState: 'choose_FI_interstitial'
    },
    children: []
});

angular.value("$SelectFiRoute", $SelectFiRoute);
_squid.$ComponentRoute;

_directive.$xoSelectFiComponent;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-select-fi/route.js
// module id = ./pages/xo-select-fi/route.js
// module chunks = 1